import { render, staticRenderFns } from "./ReqDeletionCompleted.vue?vue&type=template&id=50e4339e&"
import script from "./ReqDeletionCompleted.vue?vue&type=script&lang=js&"
export * from "./ReqDeletionCompleted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports